"use client";
import {
  Box,
  Container,
  Typography,
  Grid,
  Card,
  CardContent,
  Avatar,
  Button,
  Paper,
  List,
  ListItem,
  ListItemText,
  useMediaQuery,
  Link,
  AppBar,
  Toolbar,
  IconButton,
  Drawer,
  Menu,
  MenuItem,
} from "@mui/material";
import { styled, useTheme } from "@mui/material/styles";
import SchoolIcon from "@mui/icons-material/School";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import { FlagIcon, LogOutIcon, MenuIcon } from "lucide-react";
import { useNavigate } from "react-router";
import { useState } from "react";
import React from "react";
import { useUser } from "@/contexts/UserContext";
import { useSiteAlert } from "@/contexts/SiteAlertContext";
import { EmojiEvents } from "@mui/icons-material";
import vietnamflag from "../../assets/vietnamflag.jpg";
import MainHeader from "@/components/MainHeader";

const StyledCard = styled(Card)(({ theme }) => ({
  textAlign: "center",
  padding: theme.spacing(2),
  height: "100%",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
  "&:hover": {
    boxShadow: "0 4px 16px rgba(0,0,0,0.15)",
    transform: "translateY(-2px)",
    transition: "all 0.3s ease",
  },
}));

// const HighlightCard = styled(Paper)(({ theme }) => ({
//   padding: theme.spacing(3),
//   textAlign: "center",
//   background: "linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%)",
//   border: "2px solid #2196f3",
//   borderRadius: theme.spacing(2),
//   margin: theme.spacing(2, 0),
// }))
const HighlightCard = ({ children }: { children: React.ReactNode }) => (
  <Paper
    elevation={3}
    sx={{
      maxWidth: 700,
      mx: "auto",
      mt: 4,
      mb: 6,
      p: 4,
      border: "1px solid #4caf50",
      borderRadius: 3,
      background: "#e8f5e9",
      textAlign: "center",
    }}
  >
    {children}
  </Paper>
);

const finalists = [
  { name: "John Roy Galvez", country: "Philippines" },
  { name: "Aminudin Zakaria", country: "Indonesia" },
  { name: "Maria Cristina Arante", country: "Philippines" },
  { name: "Farah Zeehan Othman", country: "Malaysia" },
  { name: "Muhammad Faishal", country: "Indonesia" },
  { name: "Rayner Tangkui", country: "Malaysia" },
  { name: "Muhammad Afta Jadid", country: "Indonesia" },
  { name: "Chong Chiew Fung", country: "Malaysia" },
  { name: "Angelo Mallari", country: "Philippines" },
  { name: "Bagas Putra Simanjuntak", country: "Indonesia" },
];

const NavLink = styled(Link)(({ theme }) => ({
  color: "#0066FF",
  textDecoration: "none",
  marginLeft: theme.spacing(3),
  "&:hover": {
    textDecoration: "underline",
  },
  fontFamily: "Roboto",
}));

export default function TCCSummitFinalistPage() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const navigate = useNavigate();
  const { user } = useUser();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const { message, isActive } = useSiteAlert();

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleUserMenuClick = (event: React.MouseEvent<HTMLElement>) => {
    document.body.classList.remove("ro-popover-open");
    setAnchorEl(event.currentTarget);
  };
  const handleUserMenuClose = () => {
    setAnchorEl(null);
  };

  const navItems = [
    { name: "Overview", href: "./#overview" },
    { name: "Educatalyst", href: "./educatalyst" },
    { name: "Summit Finalist", href: "./summit-finalist" },
    { name: "TCC Summit 2025", href: "./tcc-summit-2025" },
    { name: "How It Works", href: "./#how-it-works" },
    { name: "Timeline", href: "./#timeline" },
    { name: "Judges", href: "./#judges" },
    { name: "Rules", href: "./#rules" },
    { name: "FAQ", href: "./#faq" },
  ];

  const mainNavItems = navItems.slice(0, 5);
  const moreNavItems = navItems.slice(5);

  const [moreAnchorEl, setMoreAnchorEl] = useState<null | HTMLElement>(null);
  const handleMoreClick = (event: React.MouseEvent<HTMLElement>) => {
    setMoreAnchorEl(event.currentTarget);
  };
  const handleMoreClose = () => {
    setMoreAnchorEl(null);
  };

  const drawer = (
    <Box onClick={handleDrawerToggle} sx={{ textAlign: "center", p: 2 }}>
      <List>
        {navItems.map((item) => (
          <ListItem
            key={item.name}
            component={Link}
            href={item.href}
            sx={{ color: "#000", textDecoration: "none" }}
          >
            <ListItemText primary={item.name} />
          </ListItem>
        ))}
      </List>
    </Box>
  );
  return (
    <Box sx={{ bgcolor: "#f8f9fa", minHeight: "100vh" }}>
      {/* <AppBar
        position="static"
        color="default"
        elevation={1}
        sx={{ backgroundColor: "white" }}
      >
        <Container>
          <Toolbar disableGutters>
            <Box sx={{ flexGrow: 1 }}>
              <img
                src="https://pythaverse.space/wp-content/uploads/2023/02/18b214a6c0c81d9644d9.png"
                alt="Pythaverse Logo"
                width="200"
                height="50"
                style={{ objectFit: "contain" }}
              />
            </Box>

            {isMobile ? (
              <>
                <IconButton
                  color="inherit"
                  aria-label="open drawer"
                  edge="end"
                  onClick={handleDrawerToggle}
                >
                  <MenuIcon />
                </IconButton>
                <Drawer
                  anchor="right"
                  open={mobileOpen}
                  onClose={handleDrawerToggle}
                  ModalProps={{
                    keepMounted: true,
                  }}
                >
                  {drawer}
                </Drawer>
              </>
            ) : (
              <Box sx={{ display: "flex", alignItems: "center" }}>
                {mainNavItems.map((item) => (
                  <NavLink key={item.name} href={item.href} sx={{ mx: 1 }}>
                    {item.name}
                  </NavLink>
                ))}
                {moreNavItems.length > 0 && (
                  <>
                    <Button
                      onClick={handleMoreClick}
                      sx={{ textTransform: "none" }}
                    >
                      More
                    </Button>
                    <Menu
                      anchorEl={moreAnchorEl}
                      open={Boolean(moreAnchorEl)}
                      onClose={handleMoreClose}
                    >
                      {moreNavItems.map((item) => (
                        <MenuItem key={item.name} onClick={handleMoreClose}>
                          <NavLink href={item.href}>{item.name}</NavLink>
                        </MenuItem>
                      ))}
                    </Menu>
                  </>
                )}
                {user?.user_login ? (
                  <Button
                    size="small"
                    variant="contained"
                    onClick={handleUserMenuClick}
                    color="primary"
                    title={user?.display_name}
                    sx={{
                      textTransform: "none",
                      borderRadius: "30px",
                      "& .MuiTypography-root": {
                        color: "white",
                      },
                      fontFamily: "Roboto",
                      fontStyle: "normal",
                      fontWeight: 700,
                      fontSize: "16px",
                      lineHeight: "19px",
                      textDecoration: "none",
                      color: "#F5F5F5",
                      marginLeft: "50px",
                    }}
                  >
                    <Typography variant="h6" noWrap component="div" ml={1}>
                      {user?.display_name}
                    </Typography>
                  </Button>
                ) : (
                  <NavLink key="btnLogin" href={user?.login_url}>
                    Login
                  </NavLink>
                )}
              </Box>
            )}

            <Menu
              anchorEl={anchorEl}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "left",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "left",
              }}
              open={Boolean(anchorEl)}
              onClose={handleUserMenuClose}
            >
              <MenuItem
                onClick={() => (window.location.href = user?.logout_url || "/")}
              >
                <LogOutIcon size={20} />
                <Typography variant="inherit" noWrap component="span" ml={1}>
                  Logout
                </Typography>
              </MenuItem>
            </Menu>
          </Toolbar>
        </Container>
      </AppBar> */}
      <MainHeader />
      <Container maxWidth="lg">
        {/* Header Section */}
        <Box textAlign="center" mb={6} mt={6}>
          <Typography
            variant="h3"
            component="h1"
            sx={{
              color: "#1976d2",
              fontWeight: "bold",
              mb: 2,
              fontSize: { xs: "2rem", md: "3rem" },
            }}
          >
            THE WAIT IS OVER!
          </Typography>
          <Typography
            variant="h5"
            component="h2"
            sx={{
              color: "#1976d2",
              mb: 3,
              fontSize: { xs: "1.2rem", md: "1.5rem" },
            }}
          >
            Unveiling the Trailblazers for the TCC Summit!
          </Typography>
          <Typography
            variant="body1"
            sx={{
              color: "#666",
              maxWidth: "800px",
              mx: "auto",
              lineHeight: 1.6,
            }}
          >
            Get ready for an{" "}
            <Box component="span" sx={{ color: "#1976d2", fontWeight: "bold" }}>
              electrifying announcement!
            </Box>{" "}
            The TCC Summit Organizing Committee is absolutely buzzing with
            excitement to pull back the curtain and reveal the phenomenal
            individuals who have conquered a fierce competition to become our{" "}
            <Box component="span" sx={{ color: "#1976d2", fontWeight: "bold" }}>
              esteemed Finalists
            </Box>{" "}
            for the highly anticipated TCC Summits!
          </Typography>
          <Typography
            variant="body1"
            sx={{
              color: "#666",
              maxWidth: "800px",
              mx: "auto",
              lineHeight: 1.6,
            }}
          >
            These aren’t just participants; they are{" "}
            <Box component="span" sx={{ color: "#1976d2", fontWeight: "bold" }}>
              visionaries, innovators, and dedicated leaders
            </Box>{" "}
            whose groundbreaking submissions have shone brightly from across the
            region. Their passion and ingenuity have truly set them apart, and
            we are on the edge of our seats to witness them ignite the Summits
            with their insights and expertise!
          </Typography>
          <Typography
            variant="body1"
            sx={{
              color: "#666",
              maxWidth: "800px",
              mx: "auto",
              lineHeight: 1.6,
            }}
          >
            But that’s not all! To truly enrich the dialogue, foster deeper
            connections, and celebrate our vibrant regional community, we are
            exceptionally proud to also welcome an esteemed{" "}
            <Box component="span" sx={{ color: "#1976d2", fontWeight: "bold" }}>
              Host Country Representative from Vietnam!
            </Box>{" "}
            This special invitation ensures a vital perspective from our
            gracious hosts, adding another incredible dimension to the Summit
            experience.
          </Typography>
          <Typography
            variant="body1"
            sx={{
              color: "#666",
              maxWidth: "800px",
              mx: "auto",
              lineHeight: 1.6,
            }}
          >
            Their collective brilliance promises to make the TCC Summits an{" "}
            <Box component="span" sx={{ color: "#1976d2", fontWeight: "bold" }}>
              unforgettable confluence of ideas and inspiration.
            </Box>{" "}
            Let’s give a resounding applause to:
          </Typography>
        </Box>
      </Container>
      <Box sx={{ backgroundColor: "#3056D3", py: 4 }}>
        <Container maxWidth="lg">
          {/* Finalists Section */}
          <Box mb={6}>
            <Box mb={4}>
              {/* Tiêu đề với icon */}
              <Box
                display="flex"
                alignItems="center"
                justifyContent="center"
                mb={1}
              >
                <EmojiEvents sx={{ color: "#ff9800", fontSize: 28, mr: 1 }} />
                <Typography
                  variant="h5"
                  component="h2"
                  sx={{
                    color: "#fff",
                    fontWeight: "bold",
                    fontSize: { xs: "1.5rem", md: "2rem" },
                  }}
                >
                  Our Esteemed Finalists
                </Typography>
              </Box>

              {/* Gạch dưới gradient */}
              <Box
                sx={{
                  height: 4,
                  width: 80,
                  mx: "auto",
                  borderRadius: 2,
                  background: "linear-gradient(to right, #1976d2, #ff9800)",
                }}
              />
            </Box>

            <Grid container spacing={3}>
              {finalists.map((finalist, index) => (
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={4}
                  lg={2.4}
                  key={index}
                  sx={{ mb: 3 }}
                >
                  <StyledCard>
                    <CardContent sx={{ textAlign: "center" }}>
                      <Avatar
                        sx={{
                          width: 80,
                          height: 80,
                          mx: "auto",
                          mb: 2,
                          bgcolor: "#1976d2",
                        }}
                      >
                        <SchoolIcon fontSize="large" />
                      </Avatar>
                      <Typography
                        variant="h6"
                        component="h3"
                        sx={{ fontWeight: "bold", fontSize: "1rem", mb: 1 }}
                      >
                        {finalist.name}
                      </Typography>
                      <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                      >
                        <LocationOnIcon
                          sx={{ fontSize: 16, color: "#f44336", mr: 0.5 }}
                        />
                        <Typography
                          variant="body2"
                          color="text.secondary"
                          sx={{ fontSize: "0.875rem" }}
                        >
                          {finalist.country}
                        </Typography>
                      </Box>
                    </CardContent>
                  </StyledCard>
                </Grid>
              ))}
            </Grid>
          </Box>
        </Container>
      </Box>

      <Container maxWidth="lg" sx={{mt: 2}}>
        {/* Host Country Representative */}
        <Box mb={6}>
          {/* Tiêu đề */}
          <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            mb={1}
          >
            <Box component="span" sx={{ mr: 1 }}>
              {/* <FlagIcon style={{ color: "#ff9800" }} /> */}
                <Box
                  component="img"
                  src={vietnamflag}
                  alt="Vietnam Flag"
                  sx={{
                    width: "48px",
                    objectFit: "cover",
                    borderRadius: 2,
                    boxShadow: 3,
                  }}
                />
            </Box>
            <Typography
              variant="h5"
              component="h2"
              sx={{
                color: "#1976d2",
                fontWeight: "bold",
                fontSize: { xs: "1.3rem", md: "1.75rem" },
              }}
            >
              Welcoming Our Host Country Representative
            </Typography>
          </Box>

          {/* Gạch dưới */}
          <Box
            sx={{
              height: 4,
              width: 80,
              mx: "auto",
              mb: 4,
              borderRadius: 2,
              background: "linear-gradient(to right, #1976d2, #ff9800)",
            }}
          />

          {/* Card giới thiệu đại diện quốc gia */}
          <HighlightCard>
            {/* Icon ngôi sao */}
            <Box
              display="flex"
              alignItems="center"
              justifyContent="center"
              mb={1}
            >
              <Box sx={{ fontSize: "2rem", color: "#ffca28" }}>⭐</Box>
            </Box>

            {/* Avatar người đại diện (dùng ảnh nếu có) */}
            {/* <Avatar
              src="/placeholder.svg?height=100&width=100"
              sx={{
                width: 100,
                height: 100,
                mx: "auto",
                mb: 2,
                bgcolor: "#1976d2",
              }}
            /> */}

            {/* Tên người đại diện */}
            <Typography
              variant="h6"
              sx={{ fontWeight: "bold", mb: 1, color: "#1976d2" }}
            >
              Oanh Thi Ngoc Pham
            </Typography>

            {/* Chức danh */}
            <Typography
              variant="body1"
              sx={{
                color: "#388e3c",
                fontWeight: 500,
                mb: 2,
              }}
            >
              Vietnam - Host Country Representative{" "}
              <Box
                component="span"
                sx={{ color: "#1b5e20", fontWeight: "bold" }}
              >
                VN
              </Box>
            </Typography>
          </HighlightCard>
          {/* Nội dung giới thiệu */}
          <Box sx={{ textAlign: "center", mb: 3 }}>
            <Typography
              variant="body2"
              sx={{
                color: "#444",
                lineHeight: 1.8,
                maxWidth: 600,
                mx: "auto",
              }}
            >
              To our incredible Finalists and our esteemed Host Country
              Representative: Your groundbreaking work has earned you this
              spotlight! This journey is a powerful testament to your vision and
              dedication. We are{" "}
              <Box
                component="span"
                sx={{ color: "#1976d2", fontWeight: "bold" }}
              >
                beyond thrilled
              </Box>{" "}
              to welcome you to the TCC Summits and champion your outstanding
              achievements!
              <br />
              <br />
              A massive thank you to every single individual who poured their
              heart and mind into their submissions. The sheer caliber of talent
              made this one of the most inspiring (and challenging!) selection
              processes yet.
              <br />
              <br />
              The countdown to the TCC Summits has truly begun! Stay tuned for
              more exhilarating updates – you won’t want to miss what’s next!
            </Typography>
          </Box>

          {/* Nút CTA */}
          <Box textAlign="center">
            <Button
              variant="contained"
              size="large"
              sx={{
                bgcolor: "#ff9800",
                color: "white",
                px: 4,
                py: 1.5,
                fontSize: "1rem",
                fontWeight: "bold",
                borderRadius: 50,
                textTransform: "none",
                "&:hover": {
                  bgcolor: "#f57c00",
                },
                textDecoration: "none"
              }}

            >
                <NavLink
                    href={`https://${process.env.API_HOST}/tcc-summit-2025/`}
                    component="a"
                    sx={{
                        mx: 1,
                        textDecoration: "none !important", // dùng !important để ghi đè
                        color: "#fff",
                    }}
                >
                🔥 Ignite Your Passion & Learn More!
                </NavLink>
            </Button>
          </Box>
        </Box>
      </Container>

      {/* Footer */}
      <Box sx={{ py: 3, bgcolor: "#f8f9fa", textAlign: "center", borderTop: "1px solid #ddd" }}>
        <Container>
          <Typography variant="body2" color="text.secondary">
            © 2025 Pythaverse. All Rights Reserved.
          </Typography>
        </Container>
      </Box>
    </Box>
  );
}
